/* Framed customizer delivery policy. Calendar days: Priority 35, Standard 49, production 16. */
(function () {
  'use strict';
  var categorySelector = '#product-builder [data-category-id="BGKHZ-5NH8Q20vxd1xZh8vGR"]';
  var formatter = new Intl.DateTimeFormat('en-US', {month:'short',day:'numeric',timeZone:'UTC'});
  var icons = {
    order:'<path d="M3 3h2l3 12h10l3-9H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/>',
    ship:'<path d="M3 6h11v11H3zM14 10h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    arrive:'<path d="m3 11 9-8 9 8M6 9v12h12V9"/>'
  };
  function method(value) {
    return /priority|fastest|3-4 weeks/i.test(value) ? 'Priority' : /economy|best value|7-8 weeks/i.test(value) ? 'Economy' : 'Standard';
  }
  function orderDay(now) {
    // Use the store's calendar date even when the shopper is in another timezone.
    var parts = new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now || new Date());
    var values = {}; parts.forEach(function(p){values[p.type]=p.value;});
    return new Date(Date.UTC(+values.year,+values.month-1,+values.day,12));
  }
  function dates(value, now) {
    var tier = method(value), day = orderDay(now), offsets = tier === 'Priority' ? [28,35] : tier === 'Economy' ? [49,56] : [42,49];
    function add(days) { var date = new Date(day);date.setUTCDate(date.getUTCDate()+days);return formatter.format(date); }
    return {method:tier,order:add(0),ship:add(16),start:add(offsets[0]),end:add(offsets[1]),range:add(offsets[0])+' – '+add(offsets[1])};
  }
  function compactRange(range) {return range.replace(/([A-Za-z]+) (\d+) – \1 (\d+)/,'$1 $2–$3');}
  function summary(value) { var d=dates(value); return d.method+' — Estimated delivery: '+d.range; }
  function icon(name) { return '<span class="myx-delivery-timeline__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">'+icons[name]+'</svg></span>'; }
  function timeline(value) {
    var d=dates(value);
    return '<ol class="myx-delivery-timeline" aria-label="Your delivery timeline">'+
      '<li>'+icon('order')+'<span class="myx-delivery-timeline__label">Order today</span><strong>'+d.order+'</strong></li>'+
      '<li>'+icon('ship')+'<span class="myx-delivery-timeline__label">Ships by</span><strong>'+d.ship+'</strong></li>'+
      '<li>'+icon('arrive')+'<span class="myx-delivery-timeline__label">Arrives</span><strong>'+compactRange(d.range)+'</strong></li></ol>';
  }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent=value; }
  function decorate(category) {
    var content = category.querySelector('.cpb-category-content');
    if (!content) return;
    var note = category.querySelector('.myx-priority-freight-note');
    if (note) note.remove();
    var selected='Standard';
    category.querySelectorAll('.cpb-option').forEach(function(option){
      var estimate=option.querySelector('.cpb-option-description'); if(!estimate)return;
      var title=option.querySelector('.cpb-option-label')?.textContent || option.querySelector('div')?.textContent || '';
      var tier=option.getAttribute('data-option-id')==='DY2i27N9Go0mXkjzvcBCoTM5'?'Standard':method(title);
      var d=dates(tier), strong=estimate.querySelector('strong');
      if (strong) setText(strong,'Estimated delivery: '+d.range);
      if (option.classList.contains('cpb-active') || option.getAttribute('aria-pressed')==='true' || option.getAttribute('aria-checked')==='true') selected=tier;
      option.dataset.myxDeliveryMethod=tier;
      option.setAttribute('aria-label',tier+'. Delivered by '+d.end+'. Estimated arrival '+d.range+(tier==='Priority'?'. Added cost varies by size.':''));
      // Native text remains a complete range for the saved design/order reader.
      estimate.setAttribute('data-myx-delivery-caption','Delivered by');
      estimate.setAttribute('data-myx-delivery-date',d.end);
      estimate.classList.add('myx-delivery-date-source');
    });
    var timing=category.querySelector('.myx-builder-delivery-timing');
    if(!timing){timing=document.createElement('div');timing.className='myx-builder-delivery-timing';content.after(timing);}
    var html='<div class="myx-delivery-timeline-heading"><span>Your delivery timeline</span><span class="myx-delivery-tier">'+selected+'</span></div>'+timeline(selected)+'<p class="myx-delivery-production">Made to order. Ships within 16 days.</p>';
    var key=selected+'|'+dates(selected).order;
    if(timing.dataset.dateKey!==key){timing.innerHTML=html;timing.dataset.dateKey=key;}
    var disclaimer=category.querySelector('.myx-delivery-estimate-disclaimer');
    if(disclaimer)disclaimer.remove();
  }
  function refresh() { var category=document.querySelector(categorySelector);if(category)decorate(category); }
  function refreshedProperties(item) {
    var props=item.properties || {};
    if(props['_Maytrix Letters Design URL'] || !(props['_Maytrix ConfigId'] || /your logo, in infinity/i.test(item.product_title || item.title || ''))) return null;
    var deliveryKeys=Object.keys(props).filter(function(key){return /delivery/i.test(key);});
    var selectedKey=deliveryKeys.find(function(key){return /^(?:choose.*delivery.*|delivery window|delivery method|delivery)$/i.test(key) && /priority|standard|economy|fastest|most popular|best value/i.test(String(props[key]));});
    var source=selectedKey?String(props[selectedKey]):deliveryKeys.map(function(key){return props[key];}).join(' ');
    if(!/priority|standard|economy|fastest|most popular|best value/i.test(source))return null;
    var next=Object.assign({},props),value=summary(source),d=dates(source);
    deliveryKeys.forEach(function(key){if(/estimated delivery|delivery commitment/i.test(key)||/Estimated delivery:/i.test(String(props[key])))next[key]=value;});
    next['Estimated Delivery']=value;next['Ships By']=d.ship;
    return Object.keys(next).some(function(key){return next[key]!==props[key];})?next:null;
  }
  async function json(url,options) {
    var response=await fetch(url,Object.assign({credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json','Accept':'application/json'},signal:AbortSignal.timeout(12000)},options));
    if(!response.ok)throw Error('Could not confirm delivery dates.');return response.json();
  }
  async function syncCheckoutDates() {
    var cart=await json('/cart.js');
    for(var i=0;i<cart.items.length;i++){
      var item=cart.items[i],props=refreshedProperties(item);
      if(props)await json('/cart/change.js',{method:'POST',body:JSON.stringify({id:item.key,quantity:item.quantity,properties:props})});
    }
  }
  var checkoutPending=false,checkoutReady=false;
  document.addEventListener('submit',async function(event){
    var form=event.target;
    if(form.id!=='CartPageForm'||!form.closest('.myx-custom-cart')||checkoutReady)return;
    var button=event.submitter || form.querySelector('[name="checkout"]');
    if(!button||button.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checkoutPending||window.__myxCartUpdating)return;
    checkoutPending=true;button.disabled=true;button.setAttribute('aria-busy','true');
    try {
      await syncCheckoutDates();checkoutReady=true;button.disabled=false;button.removeAttribute('aria-busy');form.requestSubmit(button);
    } catch(error) {
      var status=form.querySelector('.myx-delivery-checkout-error');
      if(!status){status=document.createElement('p');status.className='myx-delivery-checkout-error';status.setAttribute('role','alert');button.before(status);}
      status.textContent='We couldn’t confirm your delivery dates. Please try checkout again.';
      button.disabled=false;button.removeAttribute('aria-busy');
    } finally {checkoutPending=false;checkoutReady=false;}
  },true);
  window.MaytrixDelivery={dates:dates,summary:summary,timeline:timeline,decorate:decorate,refreshedProperties:refreshedProperties};
  document.addEventListener('DOMContentLoaded',refresh);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
  window.addEventListener('pageshow',refresh);
  document.addEventListener('CPB_ON_OPTIONS_UPDATE',refresh);
  window.setInterval(refresh,60000);
})();
